import Swal from 'sweetalert2'
import React from 'react'
import { ApiRequest } from '../../api/api'
import axios from 'axios'
import { getCookie, setCookie } from 'react-use-cookie'

type inputTypes = 'textarea' | 'text' | 'number' | any

interface WarningConfirmResult {
  dismissed?: boolean;
  value?: { reason?: string; employeeId?: number };
}

const getDefaultValue: (type:any) => any = (type:any) => {
  switch (type) {
    case 'textarea':
      return ''
    case 'text':
      return ''
    case 'number':
      return 0
    default:
      return ''
  }
}

export default class SweetAlertService {

  static successMessage = async (message?: string) => {
    await Swal.fire({
      title: 'Success!',
      text: message,
      icon: 'success',
      timer: 2000
    })
  }
  static errorMessage = async (messageText?: any, innerMessage?: any) => {
    await Swal.fire({
      title: 'Error!',
      html: messageText ? messageText : '',
      icon: 'error',
      allowOutsideClick: false,
      allowEnterKey: false,
      allowEscapeKey: false,
      showCancelButton: !!innerMessage,
      cancelButtonColor: '#d33',
      cancelButtonText: 'Close',
      confirmButtonColor: innerMessage ? '#b1b0b0' : '#d33',
      confirmButtonText: innerMessage ? 'Show details' : 'Ok'
    }).then(res => {
      console.log(res)
      if (res.isConfirmed && innerMessage) {
        Swal.fire({
          title: 'Error Details',
          html: innerMessage || '',
          allowEnterKey: false,
          allowOutsideClick: false,
          allowEscapeKey: false,
          icon: 'warning'
        })
      }
    })
  }

  static confirmMessage2: (message?: any, options?: { focusCancel?: boolean, reverseButtons?: boolean }) => Promise<boolean> = async (message?: any, options?: { focusCancel?: boolean, reverseButtons?: boolean }) => {

    return await Swal.fire({
      title: 'Are you sure?',
      html: message,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'OK',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Cancel',
      allowEnterKey: false,
      allowEscapeKey: false,
      allowOutsideClick: false,
      focusCancel: options?.focusCancel ?? true,
      reverseButtons: options?.reverseButtons ?? false,
    }).then(res => {
      return !!res.value
    })

  }
  static confirmMessage: (message?: any) => Promise<boolean> = async (message?: any) => {

    return await Swal.fire({
      title: 'Are you sure?',
      html: message,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      confirmButtonText: 'OK',
      allowEnterKey: false,
      allowEscapeKey: false,
      allowOutsideClick: false,
    }).then(res => {
      return !!res.value
    })

  }

  static confirmMessage3: (message?: any, cancelButtonText?: string, denyButtonText?: string, confirmButtonText?: string) => Promise<string | null> = async (message?: any, cancelButtonText = 'Cancel', denyButtonText = 'No', confirmButtonText = 'Yes') => {
    return await Swal.fire({
      title: 'Are you sure?',
      html: message,
      icon: 'warning',
      showCancelButton: true,
      showDenyButton: true,
      confirmButtonColor: '#3085d6',
      denyButtonColor: '#ff9800',
      cancelButtonColor: '#d33',
      confirmButtonText: confirmButtonText,
      denyButtonText: denyButtonText,
      cancelButtonText: cancelButtonText,
      allowEnterKey: false,
      allowEscapeKey: false,
      allowOutsideClick: false,
    }).then(res => {
      if (res.isConfirmed) {
        return 'confirm'
      } else if (res.isDenied) {
        return 'middle'
      } else {
        return 'cancel'
      }
    })

  }

    static lowStockMessage: (message?: any) => Promise<boolean> = async (message?: any) => {

    return await Swal.fire({
      title: 'Stock Warning',
      html: message,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      confirmButtonText: 'OK',
      allowEnterKey: false,
      allowEscapeKey: false,
      allowOutsideClick: false,
    }).then(res => {
      return !!res.value
    })

  }

  static inputConfirm = async ({ type, title = 'Confirm', textLabel = '', placeholder = 'Comment', defaultValue = getDefaultValue(type), inputOptions, handleRequired }: { type?: inputTypes; title?: string; textLabel?: string; placeholder?: string; defaultValue?: any, inputOptions?: any, handleRequired?: boolean}) => {

    // @ts-ignore
    return await Swal.fire({
      title: title,
      html: `<label for="swal-input">${textLabel}</label>`,
      input: type,
      icon: 'info',
      inputValue: defaultValue || null,
      inputPlaceholder: placeholder,
      inputValidator: handleRequired ? null : result => !result && 'Required!',
      inputAttributes: {
        autocapitalize: 'off',
      },
      showCancelButton: true,
      inputOptions: inputOptions,
      confirmButtonColor: '#d33',
      confirmButtonText: 'OK',
      allowOutsideClick: () => !Swal.isLoading()
    }).then(res => {
      if (res.isConfirmed) {
        return res.value || null
      } else {
        return undefined
      }
    })
  }
  // static loginConfirm = async ({ userNames }: { userNames: string[] }): Promise<{ userName: string; password: string } | undefined> => {
    static loginConfirm = async ({
      userName,
      userNames,
      password,
      defaultUserName
    }: {
      userName: string,
      password: string,
      userNames: string[],
      defaultUserName?: string   // ✅ 新增可选参数
    }): Promise<{ userName: string; password: string } | undefined> => {
      // const defaultUserName = getCookie('userName') ?? '';
      const savedUserName = defaultUserName ?? getCookie('userName') ?? '';

      const options = userNames.map((item: any) => {
        return savedUserName === item 
          ? `<option value="${item}" selected>${item}</option>` 
          : `<option value="${item}">${item}</option>`
      }).join('');
      
      // Show the SweetAlert2 modal
      const result = await Swal.fire({
        title: 'Login',
        html: `
          <div class="form-group">
            <label for="swal-input1">User Name</label>
            <select class="swal2-input" id="swal-input1" required>
              <option value="" disabled ${!savedUserName ? 'selected' : ''} hidden>Select</option>
              ${options}
            </select>
          </div>
          <div class="form-group">
            <label for="swal-input2">Password</label>
            <input type="password" class="swal2-input" id="swal-input2" required />
          </div>
        `,
        icon: 'info',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        confirmButtonText: 'OK',
        allowOutsideClick: () => !Swal.isLoading(),
        preConfirm: () => {
          const input1 = document.getElementById('swal-input1') as HTMLSelectElement;
          const input2 = document.getElementById('swal-input2') as HTMLInputElement;
          
          if (!input1.value.trim() || !input2.value.trim()) {
            Swal.showValidationMessage('Please fill in both fields');
            return false;
          }
          
          setCookie('userName', input1.value, {days: 30});
          return {
            userName: input1.value,
            password: input2.value
          };
        },
        allowEnterKey: true,
        didOpen: () => {
          // Focus on username if not selected, otherwise focus on password
          const usernameSelect = document.getElementById('swal-input1') as HTMLSelectElement;
          const passwordInput = document.getElementById('swal-input2') as HTMLInputElement;
          
          if (!usernameSelect.value) {
            usernameSelect.focus();
          } else {
            passwordInput.focus();
          }
          
          // Add event listener for Enter key on select element
          usernameSelect.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') {
              passwordInput.focus();
              e.preventDefault();
            }
          });
          
          // Add event listener for Enter key on password field
          passwordInput.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') {
              Swal.clickConfirm();
            }
          });
        }
      });
      
      // Return the result if confirmed, otherwise return undefined
      if (result.isConfirmed && result.value) {
        return result.value as { userName: string; password: string };
      } else {
        return undefined;
      }
    };


  static timeInputConfirm = async ({
    initialHours = 0,
    initialMinutes = 0
  }: {
    initialHours?: number,
    initialMinutes?: number
  }): Promise<{ hours: number; minutes: number } | undefined> => {
    // Show the SweetAlert2 modal
    const result = await Swal.fire({
      title: 'Enter Time',
      html: `
          <div class="form-group" style="display: flex; align-items: center; justify-content: space-between;">
            <label for="swal-hours">Hours</label>
            <input 
              type="number" 
              class="swal2-input" 
              id="swal-hours" 
              min="0" 
              max="23" 
              step="1" 
              value="${initialHours}" 
              style="width: 80px; text-align: center;" 
              required 
            />
            <label for="swal-minutes">Minutes</label>
            <input 
              type="number" 
              class="swal2-input" 
              id="swal-minutes" 
              min="0" 
              max="59" 
              step="1" 
              value="${initialMinutes}" 
              style="width: 80px; text-align: center;" 
              required 
            />
          </div>
        `,
      icon: 'info',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      confirmButtonText: 'OK',
      allowOutsideClick: () => !Swal.isLoading(),
      preConfirm: () => {
        const hoursInput = document.getElementById('swal-hours') as HTMLInputElement;
        const minutesInput = document.getElementById('swal-minutes') as HTMLInputElement;

        const hours = Number(hoursInput.value);
        const minutes = Number(minutesInput.value);

        if (isNaN(hours) || isNaN(minutes)) {
          Swal.showValidationMessage('Please enter valid numbers');
          return false;
        }

        if (hours < 0 || hours > 23) {
          Swal.showValidationMessage('Hours must be between 0 and 23');
          return false;
        }

        if (minutes < 0 || minutes > 59) {
          Swal.showValidationMessage('Minutes must be between 0 and 59');
          return false;
        }

        return {
          hours,
          minutes
        };
      },
      allowEnterKey: true,
      didOpen: () => {
        // Focus on hours input when dialog opens
        const hoursInput = document.getElementById('swal-hours') as HTMLInputElement;
        hoursInput.focus();
        hoursInput.select();

        // Add event listener for Enter key on hours input
        hoursInput.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') {
            const minutesInput = document.getElementById('swal-minutes') as HTMLInputElement;
            minutesInput.focus();
            minutesInput.select();
            e.preventDefault();
          }
        });

        // Add event listener for Enter key on minutes input
        const minutesInput = document.getElementById('swal-minutes') as HTMLInputElement;
        minutesInput.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') {
            Swal.clickConfirm();
          }
        });
      }
    });

    // Return the result if confirmed, otherwise return undefined
    if (result.isConfirmed && result.value) {
      return result.value as { hours: number; minutes: number };
    } else {
      return undefined;
    }
  };

  static deleteConfirm = async () => {
    // @ts-ignore
    return await Swal.fire({
      title: "Are you sure you want to delete this item? This is Irreversible.",
      html:
      '<div style="display: inline-block;">' +
      '<label style="display: block; ">Your name:</label>' +
      '<input type="text" class="swal2-input" style="display: inline-block; width: 400px;" id="deleteinput1" required/>' +
      '</div>' +
      '<div style="margin-top: 4px;">' +
      '<label style="display: block;">Reason:</label>' +
      '<textarea class="swal2-textarea" style="display: inline-block; width: 400px; height: 80px;" id="deleteinput2" required></textarea>' +
      '</div>',
      showCancelButton: true,
      confirmButtonText: 'OK',
      cancelButtonText: 'Cancel',
      preConfirm: () => {
        const input1 = document.getElementById('deleteinput1') as HTMLInputElement;
        const input2 = document.getElementById('deleteinput2') as HTMLInputElement;
        if (!input1.value.trim() || !input2.value.trim()) {
          Swal.showValidationMessage('Please fill in both fields');
          return false;
        }
        return [input1.value, input2.value];
      }
    }).then((result) => {
      if (result.dismiss === Swal.DismissReason.cancel) {
        return { dismissed: true };
      } else {
        return { value: result.value };
      }
    });
  };

  static warningConfirm1 = async (page?: string, triggerReason?: string): Promise<WarningConfirmResult> => {
    return SweetAlertService.showExceptionalOperationConfirm(page, triggerReason, true)
  }

  // Password-verified authorization dialog without writing the audit log.
  // Write the log via addExceptionalLog once the authorized action has succeeded.
  static warningConfirmVerifyOnly = async (page?: string, triggerReason?: string): Promise<WarningConfirmResult> => {
    return SweetAlertService.showExceptionalOperationConfirm(page, triggerReason, false)
  }

  private static showExceptionalOperationConfirm = async (page?: string, triggerReason?: string, writeLogOnConfirm?: boolean): Promise<WarningConfirmResult> => {
    const res = await axios.get('Employee/GetAllEmployee')
    const employees: { userName: string; employeeId: number; label: string }[] = (res?.data?.data || []).map((e: any) => ({
      userName: e.userName,
      employeeId: e.employeeId,
      label: `${e.firstName} ${e.lastName}`
    }))
    const employeeOptions = employees.map(e => `<option value="${e.employeeId}">${e.label}</option>`).join('')

    // @ts-ignore
    return await Swal.fire({
      title: '非常规操作确认<br/>Exceptional Operation Confirmation',
      icon: 'warning',
      html:
      '<div style="text-align: left;">' +
      '<p>This action is outside the standard workflow.<br/>Please confirm before continuing.<br/>该操作为非标准流程，请确认后执行</p>' +
      '<div style="margin-top: 8px;">' +
      '<label style="display: block; font-weight: bold;">操作页面 Page</label>' +
      `<div>${page || ''}</div>` +
      '</div>' +
      '<div style="margin-top: 8px;">' +
      '<label style="display: block; font-weight: bold;">触发原因 Trigger Reason</label>' +
      `<div>${triggerReason || ''}</div>` +
      '</div>' +
      '<div style="margin-top: 8px;">' +
      '<label style="display: block; font-weight: bold;">操作原因 Reason for Operation</label>' +
      '<textarea class="swal2-textarea" style="display: inline-block; width: 400px; height: 60px;" id="warningReasonInput" placeholder="Enter additional notes"></textarea>' +
      '</div>' +
      '<div style="margin-top: 8px;">' +
      '<label style="display: block; font-weight: bold;">员工 Employee *</label>' +
      '<select class="swal2-input" style="display: inline-block; width: 400px;" id="warningUserInput" required>' +
      '<option value="" disabled selected hidden>Select</option>' +
      employeeOptions +
      '</select>' +
      '</div>' +
      '<div style="margin-top: 8px;">' +
      '<label style="display: block; font-weight: bold;">密码 Password *</label>' +
      '<input type="password" class="swal2-input" style="display: inline-block; width: 400px;" id="warningPasswordInput" placeholder="Enter password" required/>' +
      '</div>' +
      '<p style="margin-top: 8px;">This operation will be recorded.<br/>此操作将被系统记录。</p>' +
      '</div>',
      showCancelButton: true,
      confirmButtonText: 'Confirm and Proceed',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      allowOutsideClick: () => !Swal.isLoading(),
      preConfirm: async () => {
        const userInput = document.getElementById('warningUserInput') as HTMLSelectElement;
        const passwordInput = document.getElementById('warningPasswordInput') as HTMLInputElement;
        const reasonInput = document.getElementById('warningReasonInput') as HTMLTextAreaElement;
        if (!userInput.value.trim()) {
          Swal.showValidationMessage('Please select an employee');
          return false;
        }
        if (!passwordInput.value.trim()) {
          Swal.showValidationMessage('Please enter the password');
          return false;
        }
        const selectedEmployee = employees.find(e => String(e.employeeId) === userInput.value);
        if (!selectedEmployee) {
          Swal.showValidationMessage('Please select a valid employee');
          return false;
        }
        const verifyRes = await axios.post('Employee/VerifyPassword', {
          userName: selectedEmployee.userName,
          password: passwordInput.value
        }).catch(() => null);
        if (!verifyRes) {
          Swal.showValidationMessage('Wrong password');
          return false;
        }
        if (writeLogOnConfirm) {
          await SweetAlertService.addExceptionalLog(page, triggerReason, reasonInput.value, selectedEmployee.employeeId)
        }
        return { reason: reasonInput.value, employeeId: selectedEmployee.employeeId };
      }
    }).then((result) => {
      // Treat every dismissal (cancel / esc / backdrop click) as blocked.
      if (result.isConfirmed) {
        return { value: result.value as { reason?: string; employeeId?: number } };
      }
      return { dismissed: true };
    });
  };

  static addExceptionalLog = async (page?: string, triggerReason?: string, reason?: string, createBy?: number) => {
    await axios.post('ExceptionalLog/AddExceptionalLog', {
      page: page || '',
      triggerReason: triggerReason || '',
      reason: reason || '',
      createAt: new Date().toISOString(),
      createBy: createBy ?? parseInt(getCookie('id'))
    }, {
      headers: { isLoading: false }
    }).catch(() => null)
  }

  static warningMessage = async (message?: string, title: string = 'Warning') => {
    await Swal.fire({
      title: title,
      text: message,
      icon: 'warning',
      timer: 2000
    })
  }

  static warningConfirm = async (message?: string, title: string = 'Warning') => {
    return await Swal.fire({
      title: title,
      text: message,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      confirmButtonText: 'Continue',
      cancelButtonText: 'Cancel',
      allowOutsideClick: false,
      allowEnterKey: false,
      allowEscapeKey: false,
    }).then((result) => {
      if (result.dismiss === Swal.DismissReason.cancel) {
        return { dismissed: true };
      } else {
        return { dismissed: false };
      }
    });
  }

  /**
   * Lightweight form validation warning - displays without blocking
   * Use for immediate form validation feedback
   * Supports displaying multiple error messages combined
   */
  static validationWarning = (messageText?: string | string[]) => {
    const { message } = require('antd')
    // Combine all messages into one
    const messages = Array.isArray(messageText) ? messageText : [messageText || 'Please check form for errors']
    const combinedMessage = messages.length > 1
      ? `Validation Errors:\n• ${messages.join('\n• ')}`
      : messages[0]

    message.warning({
      content: combinedMessage,
      duration: 6,
      style: {
        fontSize: '16px',
        fontWeight: 'bold',
        marginTop: '10vh',
        whiteSpace: 'pre-line',
        lineHeight: '1.8'
      }
    })
  }

  /**
   * Lightweight form validation error - displays without blocking (RED)
   * Use for immediate form validation feedback
   * Supports displaying multiple error messages combined
   */
  static validationError = (messageText?: string | string[]) => {
    const { message } = require('antd')
    // Combine all messages into one with bullet points
    const messages = Array.isArray(messageText) ? messageText : [messageText || 'Please complete all required fields']
    const combinedMessage = messages.length > 1
      ? `Validation Errors:\n• ${messages.join('\n• ')}`
      : messages[0]

    message.error({
      content: combinedMessage,
      duration: 8,
      style: {
        fontSize: '16px',
        fontWeight: 'bold',
        marginTop: '10vh',
        backgroundColor: '#fff2f0',
        border: '2px solid #ff4d4f',
        padding: '12px 16px',
        borderRadius: '4px',
        whiteSpace: 'pre-line',
        lineHeight: '1.8'
      }
    })
  }
}

